export const MR_CLAIM_LIST = 'MR_CLAIM_LIST';
export const MR_CLAIM_LOADER = 'MR_CLAIM_LOADER';
